import { render, staticRenderFns } from "./ad_list.vue?vue&type=template&id=5a1c2ad0&scoped=true&"
import script from "./ad_list.vue?vue&type=script&lang=js&"
export * from "./ad_list.vue?vue&type=script&lang=js&"
import style0 from "./ad_list.vue?vue&type=style&index=0&id=5a1c2ad0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1c2ad0",
  null
  
)

export default component.exports